import s from '@/components/layouts/Connectors/GoogleAnalyticsConnector/GoogleAnalyticsConnector.module.scss';
import { TextInput } from '@tremor/react';
import { forwardRef, HTMLAttributes, Ref } from 'react';
import { TextInputProps } from '@tremor/react/dist/components/input-elements/TextInput/TextInput';

type KeyInputProps =
  | ({
      title: string;
      label: string;
      placeholder?: string;
      textarea?: boolean;
    } & TextInputProps)
  | ({
      title: string;
      label: string;
      placeholder?: string;
      textarea: boolean;
      error?: boolean;
      errorMessage?: string;
    } & HTMLAttributes<HTMLTextAreaElement>);

export const KeyInput = forwardRef<HTMLInputElement | HTMLTextAreaElement, KeyInputProps>(
  (
    {
      title,
      label,
      placeholder = 'Enter Key',
      id,
      textarea = false,
      error,
      errorMessage,
      ...rest
    },
    ref,
  ) => {
    if (textarea) {
      return (
        <label htmlFor={id}>
          <p className={s.manualEditInputUpperLabel}>{title}</p>
          <p className={s.manualEditInputLowerLabel}>{label}</p>
          <textarea
            {...(rest as HTMLAttributes<HTMLTextAreaElement>)}
            className={[s.manualEditInput, s.manualEditTextarea].join(' ')}
            id={id}
            ref={ref as Ref<HTMLTextAreaElement>}
            placeholder={placeholder}
          ></textarea>
          {error ? (
            <p className="tremor-TextInput-errorMessage text-sm text-rose-500">
              {errorMessage}
            </p>
          ) : null}
        </label>
      );
    } else {
      return (
        <label htmlFor={id}>
          <p className={s.manualEditInputUpperLabel}>{title}</p>
          <p className={s.manualEditInputLowerLabel}>{label}</p>
          <TextInput
            errorMessage={errorMessage}
            error={error}
            {...(rest as TextInputProps)}
            className={s.manualEditInput}
            id={id}
            ref={ref as Ref<HTMLInputElement>}
            placeholder={placeholder}
          />
        </label>
      );
    }
  },
);

KeyInput.displayName = 'KeyInput';
